import React, { FC, lazy, Suspense, useState } from 'react'

import { FocusNode } from '@please/lrud'
import { scroller } from 'react-scroll'

import { LineLoader } from '@/components/LinesGroup/LineLoader'
import { fetchStatus } from '@/constants/common'
import { Direction, focusIds, orientation } from '@/constants/focus'
import { scrollOptions } from '@/constants/scrollers'
import { EventDetailSliderProps } from '@/types/componentsPropsTypes'
import { LinesGroupType } from '@/types/sliderTypes'

const LinesGroup: FC<LinesGroupType> = lazy(
  () => import('@/components/LinesGroup/LinesGroup'),
)

import { useGetMemoizedLines } from './hooks'

export const EventDetailsSlider: FC<EventDetailSliderProps> = ({ isPopup }) => {
  const [defaultFocusChild, setDefaultFocusChild] = useState<number>(0)

  const { status, memoizedLines } = useGetMemoizedLines()

  const onMove = (e: MoveEvent) => {
    const nextFocusId = e.nextChildNode.focusId
    const currentChildIndex =
      e.direction === Direction.Forward
        ? Number(e.prevChildIndex) + 1
        : Number(e.prevChildIndex) - 1
    setDefaultFocusChild(currentChildIndex)
    scroller.scrollTo(nextFocusId, scrollOptions.CalendarScroll)
  }

  if (!memoizedLines.length) {
    return null
  }

  return (
    <FocusNode
      elementType="section"
      focusId={focusIds.EVENT_SLIDER}
      defaultFocusChild={defaultFocusChild}
      orientation={orientation.VERTICAL}
      onMove={onMove}
      className="content-wrapper"
    >
      {status === fetchStatus.COMPLETED ? (
        <Suspense>
          <LinesGroup
            groupData={memoizedLines}
            scrollOptions={scrollOptions.EventDetailPageScroll}
            isPopup={isPopup}
            isEventPage
          />
        </Suspense>
      ) : (
        <LineLoader />
      )}
    </FocusNode>
  )
}
